import { render, staticRenderFns } from "./Couple.vue?vue&type=template&id=03a51116"
import script from "./Couple.vue?vue&type=script&lang=js"
export * from "./Couple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports